import gql from 'graphql-tag';

export default gql`
  mutation publishDraft($id: UUID!) {
    publishDraft(_id: $id) {
      _id
    }
  }
`;
